import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import { dashboardActions } from '../../../../store/slices/dashboardSlice/dashboardSlice';
import { ErrorsMessage } from '../ModalAddManagerInfo/useModalAddManagerInfo';
import { ManagerInformation } from '../../types/dashboardInformation';
import { editManager } from '../../../../store/slices/dashboardSlice/action';
import { getManager } from '../../helpers/getManager';
import { useTranslation } from 'react-i18next';

export const useModalEditManagerInfo = () => {
    const { t } = useTranslation();

    const dispatch = useDispatch();
    const { modalMode, isEditedManager, currentManagerId, modalLoader } = useSelector(
        //@ts-ignore
        (state) => state.dashboardReducer
    );
    const [openSecondModal, setOpenSecondModal] = useState(false);
    const [errorsMessage, setErrorsMessage] = useState<ErrorsMessage>({ name: null, email: null });
    const [form, setForm] = useState<ManagerInformation>({
        full_name: '',
        position: '',
        email: '',
        phone: '',
        preview_url: null,
    });

    const onForm = useCallback(
        (name: string, value: string) => {
            dispatch(dashboardActions.changeIsEditedManager(true));
            setForm({ ...form, [name]: value });
        },
        [dispatch, form]
    );

    const clearFormData = () => {
        onCancelSecondModal();
        dispatch(dashboardActions.onModalMode(null));
        dispatch(dashboardActions.changeIsEditedManager(false));
        setForm({
            full_name: '',
            position: '',
            email: '',
            phone: '',
            preview_url: null,
        });
    };

    const onCancelSecondModal = useCallback(() => {
        setOpenSecondModal(false);
    }, []);

    const onCancel = useCallback(() => {
        if (isEditedManager) {
            setOpenSecondModal(true);
        } else {
            clearFormData();
        }
    }, [isEditedManager]);

    const onSubmit = useCallback(() => {
        if (validateForm()) {
            dispatch(editManager(form));
        }
    }, [form]);

    const validateForm = () => {
        const newErrors: ErrorsMessage = {} as ErrorsMessage;
        if (!form.full_name.trim()) {
            newErrors.name = t('useModalEditManagerInfovalidateForm.name');
        }
        if (!form.email.trim()) {
            newErrors.email = t('useModalEditManagerInfovalidateForm.empty_email');
        }
        if (form.email.trim() && !/\S+@\S+\.\S+/.test(form.email)) {
            newErrors.email = t('useModalEditManagerInfovalidateForm.email');
        }
        setErrorsMessage(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    useEffect(() => {
        if (modalMode === 'editManagerInfo') {
            const fetchManagerInfo = async () => {
                try {
                    dispatch(dashboardActions.onModalLoader(true));
                    const data = await getManager(currentManagerId);
                    setForm(data);
                } catch (error) {
                    console.error(error.message);
                    dispatch(dashboardActions.onModalMode(null));
                } finally {
                    dispatch(dashboardActions.onModalLoader(false));
                }
            };

            fetchManagerInfo();
        }
    }, [modalMode, currentManagerId]);

    return {
        modalMode,
        form,
        onForm,
        onCancel,
        errorsMessage,
        onSubmit,
        onCancelSecondModal,
        clearFormData,
        openSecondModal,
        modalLoader,
    };
};
